import { Component } from '@angular/core';

@Component({
  selector: 'app-home-carousel-item2',
  imports: [],
  templateUrl: './home-carousel-item2.html',
  styleUrl: './home-carousel-item2.scss'
})
export class HomeCarouselItem2 {

}
